export const pointLayerDefinition = {
    geometryType: 'esriGeometryPoint',
    objectIdField: 'uniqueId',
    extent: {
        xmin: 112.11951723431639,
        ymin: -84.24316855655076,
        xmax: 131.37433713535938,
        ymax: 24.052603348828143,
        spatialReference: {
            wkid: 7844,
            latestWkid: 7844
        }
    },
    fields: [
        {
            name: 'objectid',
            type: 'esriFieldTypeOID',
            alias: 'objectid',
            editable: false,
            nullable: false
        },
        {
            name: 'guid',
            type: 'esriFieldTypeString',
            alias: 'guid',
            editable: true,
            nullable: false,
            length: 50
        },
        {
            name: 'id',
            type: 'esriFieldTypeInteger',
            alias: 'id',
            editable: true,
            nullable: false
        },
        {
            name: 'type',
            type: 'esriFieldTypeInteger',
            alias: 'type',
            editable: true,
            nullable: true
        },
        {
            name: 'x',
            type: 'esriFieldTypeDouble',
            alias: 'x',
            editable: true,
            nullable: true
        },
        {
            name: 'y',
            type: 'esriFieldTypeDouble',
            alias: 'y',
            editable: true,
            nullable: true
        },
        {
            name: 'z',
            type: 'esriFieldTypeDouble',
            alias: 'z',
            editable: true,
            nullable: true
        },
        {
            name: 'name',
            type: 'esriFieldTypeString',
            alias: 'name',
            length: 32,
            editable: true,
            nullable: true
        },
        {
            name: 'markstatus',
            type: 'esriFieldTypeString',
            alias: 'markstatus',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'fieldrecordreference',
            type: 'esriFieldTypeString',
            alias: 'fieldrecordreference',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'generalcomment',
            type: 'esriFieldTypeString',
            alias: 'generalcomment',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'pointhorizontalmethod',
            type: 'esriFieldTypeString',
            alias: 'pointhorizontalmethod',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'pointhorizontalaccuracy',
            type: 'esriFieldTypeString',
            alias: 'pointhorizontalaccuracy',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'surveyedindicator',
            type: 'esriFieldTypeString',
            alias: 'surveyedindicator',
            editable: true,
            nullable: true,
            length: 10
        },
        {
            name: 'legacypointtype',
            type: 'esriFieldTypeString',
            alias: 'legacypointtype',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'pointisnewindicator',
            type: 'esriFieldTypeString',
            alias: 'pointisnewindicator',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'importlayername',
            type: 'esriFieldTypeString',
            alias: 'importlayername',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'importfilename',
            type: 'esriFieldTypeString',
            alias: 'importfilename',
            editable: true,
            nullable: true,
            length: 255
        },
        {
            name: 'legacylocalpointno',
            type: 'esriFieldTypeInteger',
            alias: 'legacylocalpointno',
            editable: true,
            nullable: true
        },
        {
            name: 'legacyrecordid',
            type: 'esriFieldTypeInteger',
            alias: 'legacyrecordid',
            editable: true,
            nullable: true
        },
        {
            name: 'origx',
            type: 'esriFieldTypeDouble',
            alias: 'origx',
            editable: true,
            nullable: true
        },
        {
            name: 'origy',
            type: 'esriFieldTypeDouble',
            alias: 'origy',
            editable: true,
            nullable: true
        },
        {
            name: 'visible',
            type: 'esriFieldTypeString',
            alias: 'visible',
            editable: true,
            nullable: true,
            length: 5
        },
        {
            name: 'hiddenonenlargements',
            type: 'esriFieldTypeString',
            alias: 'hiddenOnEnlargements',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'markdescription',
            type: 'esriFieldTypeString',
            alias: 'markdescription',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'installlocationcomment',
            type: 'esriFieldTypeString',
            alias: 'installlocationcomment',
            editable: true,
            nullable: true,
            length: 1024
        }
    ]
};
